/**
 * Created by olga on 05.10.2026
 *
 */

const NoAdsOfferLogic = function (offer) {
    OfferLogic.call(this, offer);
};

NoAdsOfferLogic.prototype = Object.create(OfferLogic.prototype);
NoAdsOfferLogic.prototype.constructor = NoAdsOfferLogic;

NoAdsOfferLogic.prototype.getRewards = function () {
    return this.getProduct().reward;
};

NoAdsOfferLogic.prototype.getIconTitle = function () {
    return this.getPriceText();
};

NoAdsOfferLogic.prototype.needToNudge = function () {
    const lastNudgeTime = cleverapps.dataLoader.localStorage.getItem(DataLoader.TYPES.NO_ADS_NUDGE_TIME);

    if (lastNudgeTime && parseInt(lastNudgeTime) + NoAdsOfferLogic.NUDGE_TIMEOUT > Date.now()) {
        return false;
    }

    return cleverapps.noAds.canBuy();
};

NoAdsOfferLogic.prototype.updateNudgeTime = function () {
    cleverapps.dataLoader.save(DataLoader.TYPES.NO_ADS_NUDGE_TIME, Date.now());
};

NoAdsOfferLogic.NUDGE_TIMEOUT = cleverapps.parseInterval("30 minutes");
